import React from 'react'
import './TryToFunn.css'
import { Cube } from '../../components/Comp/AllComponents'
// import { Toolbar } from '@mui/material'

const TryToFun = () => {
    return (
        <>
            <div className="fun">
                <Cube />
            </div>
        </>
    )
}

export default TryToFun
